module.exports = __webpack_public_path__ + "static/ursuLogo-4c7fd095a5c35fa209d29adef225ac24.png";